// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1ES5g","inner":"Form_inner__1WeNz","range":"Form_range__1PFKf","name":"Form_name__12ewE","actions":"Form_actions__1dvUV"};